export let ARTICLE_TYPE = /*#__PURE__*/function (ARTICLE_TYPE) {
  ARTICLE_TYPE["HELP_ARTICLE"] = "HELP_ARTICLE";
  ARTICLE_TYPE["WHATS_NEW"] = "WHATS_NEW";
  return ARTICLE_TYPE;
}({});